export default "__VITE_ASSET__F23vjFHS__"